/* eslint-disabled */

export default class QuestionConditionExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
